import { faBars, faBasketShopping, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import headerLogo from "../../../assets/images/header-logo.svg"
import "./header.css"
import { Form, FormControl } from 'react-bootstrap';
import { faCircleUser } from '@fortawesome/free-regular-svg-icons';

const Header = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [isOpen, setIsOpen] = useState(false);
  const [searchText, setSearchText] = useState('');

  const handleSearchIconClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <header className="header text-white d-flex align-items-center justify-content-between">
        <span role='button' className='d-flex align-items-center gap-3' onClick={handleShow}>
          <FontAwesomeIcon icon={faBars} />
          Menu
        </span>
        <strong className='header-logo d-inline-block'>
          <a href='#' className='d-inline-block'>
            <img src={headerLogo} alt='logo' />
          </a>
        </strong>
        <div className='right-icons d-flex align-items-center gap-3'>
          <Form>
            <div className="position-relative d-flex align-items-center gap-3">
              <FormControl
                type="text"
                placeholder="Search"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                style={{ display: isOpen ? 'block' : 'none' }}
              />
              <FontAwesomeIcon icon={faSearch} role='button'
                onClick={handleSearchIconClick}
              />
            </div>
          </Form>
          <FontAwesomeIcon icon={faBasketShopping} role='button' />
          <FontAwesomeIcon icon={faCircleUser} role='button' />
        </div>
      </header>
      <Offcanvas show={show} onHide={handleClose}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Offcanvas</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          Some text as placeholder. In real life you can have the elements you
          have chosen. Like, text, images, lists, etc.
        </Offcanvas.Body>
      </Offcanvas>
    </>
  )
}

export default Header